// ─────────────────────────────────────────────────────────────────────────────
// AlertsTab.js — the node's active alerts, or a centred empty state when there
// are none. Alerts come straight from the enriched-node record.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../NodeDetailModal.module.css";
import { ShieldLargeIcon } from "../icons";

export default function AlertsTab({ detail }) {
  const { alerts } = detail;

  if (alerts.length === 0) {
    return (
      <div className={styles.tab}>
        <div className={styles.alertsEmpty}>
          <span className={styles.alertsEmptyIcon}><ShieldLargeIcon /></span>
          <span className={styles.alertsEmptyText}>No alerts</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tab}>
      <div className={styles.list}>
        {alerts.map((a, i) => (
          <div key={i} className={styles.alertRow}>
            <span className={styles.alertIcon}>⚠</span>
            <span className={styles.alertText}>{a}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
